export default __webpack_public_path__ + "assets/images/monitor-api-traffic-79928180ab8379deecdb4105799c1588.png";